import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Dollar } from "@faire/web/slate/icons/foundation/Dollar";
import React from "react";
import { usePaymentPayoutsArticles } from "../instantAnswers/articles/usePaymentPayoutsArticles";
import { usePaymentUpdatePayoutsArticles } from "../instantAnswers/articles/usePaymentUpdatePayoutsArticles";
import { adyenIssue } from "../instantAnswers/payments-adyenIssue";
import { discrepancyInPayoutTotal } from "../instantAnswers/payments-discrepancyInPayoutTotal";
import { payoutCalculated } from "../instantAnswers/payments-payoutCalculated";
import { PayoutNotReceived } from "../instantAnswers/payments-payoutNotReceived";
import { setUpPayouts } from "../instantAnswers/payments-setUpPayouts";
import { taxForm1099 } from "../instantAnswers/payments-taxForm1099";
import { updatePayouts } from "../instantAnswers/payments-updatePayouts";
export var usePaymentsBrandNodes = function usePaymentsBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  var updatePayoutsArticles = usePaymentUpdatePayoutsArticles();
  var payoutsArticles = usePaymentPayoutsArticles();
  return {
    Payments: {
      id: "Payments",
      label: strictLocalize({
        id: "G0P64D",
        defaultMessage: [{
          "type": 0,
          "value": "Paiements"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Dollar, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      level: 1,
      sidebarTitle: strictLocalize({
        id: "4aMFXo",
        defaultMessage: [{
          "type": 0,
          "value": "Problème de paiement"
        }]
      }),
      children: ["SetUpPayouts", "AdyenIssue", "PayoutNotReceived", "HowPayoutsCalculated", "DiscrepancyInPayoutTotal", "UpdatePayoutTerms", "TaxForm1099"]
    },
    SetUpPayouts: {
      id: "SetUpPayouts",
      label: strictLocalize({
        id: "CU2PGr",
        defaultMessage: [{
          "type": 0,
          "value": "Configurer les paiements"
        }]
      }),
      articles: payoutsArticles,
      instantAnswer: setUpPayouts(strictLocalize),
      level: 2
    },
    AdyenIssue: {
      id: "AdyenIssue",
      label: strictLocalize({
        id: "TPlwdb",
        defaultMessage: [{
          "type": 0,
          "value": "Problème avec Adyen"
        }]
      }),
      instantAnswer: adyenIssue(strictLocalize),
      articles: [articles.InvoicesAndBilling.PAYOUT_EUROPEAN, articles.InvoicesAndBilling.PAYOUT_AUSTRALIAN, articles.InvoicesAndBilling.TROUBLESHOOTING_WITH_ADYEN],
      level: 2
    },
    PayoutNotReceived: {
      id: "PayoutNotReceived",
      label: strictLocalize({
        id: "n+V1wr",
        defaultMessage: [{
          "type": 0,
          "value": "Paiement non reçu"
        }]
      }),
      articles: [articles.InvoicesAndBilling.ISSUE_WITH_MY_ORDER_PAYOUT],
      instantAnswer: PayoutNotReceived(strictLocalize),
      level: 2
    },
    AboutPayoutCalculations: {
      id: "AboutPayoutCalculations",
      label: strictLocalize({
        id: "vWjqTJ",
        defaultMessage: [{
          "type": 0,
          "value": "À propos du calcul des paiements"
        }]
      }),
      instantAnswer: payoutCalculated(strictLocalize),
      articles: [articles.InvoicesAndBilling.NON_NAM_SELL_ON_FAIRE, articles.InvoicesAndBilling.NAM_SELL_ON_FAIRE],
      level: 2
    },
    DiscrepancyInPayoutTotal: {
      id: "DiscrepancyInPayoutTotal",
      label: strictLocalize({
        id: "ZaieX6",
        defaultMessage: [{
          "type": 0,
          "value": "Différence dans le total du paiement"
        }]
      }),
      articles: [articles.InvoicesAndBilling.NON_NAM_SELL_ON_FAIRE, articles.InvoicesAndBilling.NAM_SELL_ON_FAIRE],
      instantAnswer: discrepancyInPayoutTotal(strictLocalize),
      level: 2
    },
    UpdatePayoutTerms: {
      id: "UpdatePayoutTerms",
      label: strictLocalize({
        id: "ESG8kG",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier les conditions de paiement"
        }]
      }),
      articles: updatePayoutsArticles,
      instantAnswer: updatePayouts(strictLocalize),
      level: 2
    },
    DownloadMyTaxForms: {
      id: "DownloadMyTaxForms",
      label: strictLocalize({
        id: "mhSYtQ",
        defaultMessage: [{
          "type": 0,
          "value": "Télécharger mes formulaires fiscaux"
        }]
      }),
      instantAnswer: taxForm1099(strictLocalize),
      articles: [articles.InvoicesAndBilling.TAX_FORM_1099],
      level: 2
    }
  };
};